export const INGREDIENT_UNITS = ["Spsk", "tsk", "gram", "dl", "ml", "stk"];

export const EDITORIAL_TEMPLATES = [
  { value: "journal", label: "Journal" },
  { value: "feature", label: "Feature" },
  { value: "gallery", label: "Galleri" },
  { value: "grounding", label: "Refleksion-journal" },
];

export function normalizeComposition(value, { postType } = {}) {
  if (postType === "recipe" || value === "recipe") return "recipe";
  if (!value || value === "classic") return "journal";
  if (value === "grounding") return "grounding";
  if (value === "wine_tasting") return "wine_tasting";
  const found = EDITORIAL_TEMPLATES.find((t) => t.value === value);
  return found ? found.value : "journal";
}

export const VISIBILITY_OPTIONS = [
  { value: "private", label: "Privat" },
  { value: "users", label: "Brugere" },
  { value: "public", label: "Offentlig" },
];

export function normalizeVisibility(value) {
  if (!value) return "private";
  const found = VISIBILITY_OPTIONS.find((t) => t.value === value);
  return found ? found.value : "private";
}
